export default {
	OutInvoice: 'Hóa đơn đầu ra',
	InvoiceDeleted: 'Hóa đơn đã xóa',
	Export: 'Xuất khẩu',
	NoDataOutInvoice:
		'Chưa có hóa đơn đầu ra vui lòng tải hóa đơn đầu ra hoặc kết nối Cơ quan thuế để tự động ghi nhận hóa đơn đầu ra.',
	CanUploadXML: 'Bạn có thể tải file hóa đơn với định dạng xml/inv tại đây.',
	ViewGuid: 'Xem hướng dẫn',
	NoData: 'Không có dữ liệu',

	NotifyFirstUse: {
		MessageDescription: `Tính năng sử dụng cho hóa đơn đầu ra của tất cả các NCC Hóa đơn khác MISA meInvoice, giúp tự
        động cập nhật và hạch toán`,
		MessageDescriptionMISAMeInvoice: `phát hành
        hóa đơn để tự động đồng bộ vào phần mềm kế toán và lập chứng từ miễn phí.`
	},

	//Bổ sung
	Understood: 'Đã hiểu',
	SelectNumberInvoice: ' Đã chọn {number} hóa đơn',
	StatusInvoice: 'Trạng thái hóa đơn',
	ViewDetailInvoice: 'Xem chi tiết hóa đơn',
	ViewInvoice: 'Xem hóa đơn',
	TaxAuthorityCreatedDateOutInvoice: 'Ngày gửi đến CQT',

	// Chặn điều chuyển HĐ đầu ra đến đơn vị đặc thù (PBI #599507)
	blockedPopupTitle: 'Không thể điều chuyển hóa đơn đầu ra',
	blockedTransferToSpecialUnit:
		'Đơn vị nhận điều chuyển <strong>{unitName}</strong> là đơn vị có đặc thù kiểm tra hóa đơn của bên thứ 3 và <span style="color:#f5222d;font-weight:600">không có chức năng</span> nhận hóa đơn đầu ra.',
	blockedTransferToSpecialUnitNote: 'Vui lòng kiểm tra lại đơn vị nhận để tránh sai sót.'
};
